import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule, provideToastr } from 'ngx-toastr';
import { WebcamModule } from 'ngx-webcam';
import { AppComponent } from './app.component';
import { ErrorComponent } from "./modules/facetec/pages/facetec/error/error.component";
import { FaceTecComponent } from './modules/facetec/pages/facetec/facetec/facetec.component';
import { LandingComponent } from './modules/facetec/pages/facetec/landing/landing.component';
import { LanguageSwitcherComponent } from "./modules/facetec/pages/facetec/language-switcher/language-switcher.component";
import { ReviewComponent } from "./modules/facetec/pages/facetec/review/review.component";
import { SignatureComponent } from './modules/facetec/pages/facetec/signature/signature.component';
import { SkipCaptureComponent } from './modules/facetec/pages/facetec/skip-capture/skip-capture.component';
import { SubmitComponent } from './modules/facetec/pages/facetec/submit/submit.component';
import { TakePhotoComponent } from './modules/facetec/pages/facetec/takephoto/takephoto.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { ConfigService } from "./service/config.service";
import { EventsService } from "./service/events.service";
import { RefService } from "./service/ref.service";
import { SessionService } from "./service/session.service";
import { FaceTecSDKServiceV10 } from "./service/FaceTecSDKServiceV10";

const routes: Routes = [
	// { path: 'home', component: HomeComponent },
	// { path: 'report', loadChildren: () => import('./modules/reporting/reporting.module').then(m => m.ReportingModule) },
	// { path: 'release-management', loadChildren: () => import('./modules/release-management/release-management.module').then(m => m.ReleaseManagementModule) },
	{ path: 'start', component: LandingComponent },
	{ path: 'facetec', loadChildren: () => import('./modules/facetec/facetec.module').then(m => m.FaceTecModule) },
	{ path: 'sign', component: SignatureComponent },
	{ path: 'submit', component: SubmitComponent },
	{ path: 'skip', component: SkipCaptureComponent },
	{ path: 'takephoto', component: TakePhotoComponent },
	{ path: 'review', component: ReviewComponent },
	{ path: 'error', component: ErrorComponent },
	// { path: 'ekyc', loadChildren: () => import('./modules/ekyc/ekyc.module').then(m => m.EkycModule) },
	// { path: '**', redirectTo: '/kiosk/list', pathMatch: 'full' },
	{ path: '**', component: LandingComponent },
	// { path: '**', component: FaceTecComponent },
];

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
	declarations: [
		AppComponent,
  		MainPageComponent,
		FaceTecComponent,
		TakePhotoComponent,
		SubmitComponent,
		SignatureComponent,
		LandingComponent,
		SkipCaptureComponent,
		ReviewComponent,
		ErrorComponent,
		LanguageSwitcherComponent
	],
	imports: [
		BrowserModule,
		NgbModule,
		WebcamModule,
		ZXingScannerModule,
		FontAwesomeModule,
		FormsModule,
		HttpClientModule,
		RouterModule.forRoot(routes, { useHash: false }),
		BrowserAnimationsModule,
		NgxSpinnerModule,
		ToastrModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
			  provide: TranslateLoader,
			  useFactory: HttpLoaderFactory,
			  deps: [HttpClient]
			},
			defaultLanguage: 'ar'
		  })		
	],
	exports: [RouterModule,NgxSpinnerModule],
	bootstrap: [AppComponent],
	providers: [
		FaceTecSDKServiceV10,
		ConfigService,
		RefService,
		SessionService,
		// PhotoIDMatchService,
		EventsService,
		provideAnimations(), // required animations providers
    	provideToastr(), // Toastr providers
	],
})
export class AppModule { }